import React, { createContext, useContext, useMemo, useState } from "react";

type PopupAccordionContextValue = {
  openId: number | null;
  toggle: (id: number) => void;
  isAnyOpen: boolean;
};

const PopupAccordionContext = createContext<PopupAccordionContextValue | null>(null);

export const PopupAccordionProvider = ({
  children,
  defaultOpenId = null,
}: {
  children: React.ReactNode;
  defaultOpenId?: number | null;
}) => {
  const [openId, setOpenId] = useState<number | null>(defaultOpenId);

  const toggle = (id: number) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  const value = useMemo(
    () => ({
      openId,
      toggle,
      isAnyOpen: openId !== null,
    }),
    [openId]
  );

  return (
    <PopupAccordionContext.Provider value={value}>
      {children}
    </PopupAccordionContext.Provider>
  );
};

export const usePopupAccordion = () => {
  const ctx = useContext(PopupAccordionContext);
  if (!ctx) throw new Error("usePopupAccordion must be used within PopupAccordionProvider");
  return ctx;
};